import React from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import {useDispatch} from "react-redux";
import {setCabinetDepositOpenModalStatus} from "../../../store/cabinet/action";

const CabinetDepositNew = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                <div className={Styles.titleRow}>
                    <div className={Styles.title}>
                        {t("Открытие депозита")}
                    </div>
                </div>


                <button
                    type="button"
                    className={Styles.convertBtn}
                    onClick={()=>{dispatch(setCabinetDepositOpenModalStatus(true))}}
                    disabled={false}
                >
                    {t("Открыть новый депозит")}
                </button>
            </div>
        </div>
    );
};

export default CabinetDepositNew;